import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentUser } from 'selectors/user';

import GetSuggestedStreams from './GetSuggestedStreams.graphql';

export default function useSuggestedFollows({
  followedProfileIds,
  followedTagNames,
  skip,
}) {
  const currentUser = useSelector(selectCurrentUser);
  const { data: suggestedFollows } = useQuery(GetSuggestedStreams, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
    skip,
  });

  const { suggestedProfiles, suggestedTags } = useMemo(() => {
    if (!suggestedFollows?.result) {
      return { suggestedProfiles: [], suggestedTags: [] };
    }

    // Filter out duplicates
    const suggestedProfiles = followedProfileIds
      ? suggestedFollows.result.profiles.filter(
          profile =>
            !followedProfileIds.has(profile.user.id) &&
            String(currentUser.id) !== profile.user.id
        )
      : [];
    // Filter out duplicates
    const suggestedTags = followedTagNames
      ? suggestedFollows.result.tags.filter(
          tag => !followedTagNames.has(tag.name)
        )
      : [];

    return {
      suggestedProfiles,
      suggestedTags,
    };
  }, [currentUser.id, suggestedFollows, followedProfileIds, followedTagNames]);

  return {
    suggestedProfiles,
    suggestedTags,
  };
}
